// Map wiki image paths to local image filenames
export function getLocalImagePath(wikiImagePath: string): string {
  // Handle null/undefined input
  if (!wikiImagePath) {
    console.warn('Empty image path provided, using placeholder');
    return '/images/placeholder.png';
  }
  
  // Extract the base filename from the wiki path
  const match = wikiImagePath.match(/\/([^\/]+\.(?:png|PNG|jpg|jpeg))$/);
  if (!match) {
    console.warn('Could not extract filename from path:', wikiImagePath);
    return '/images/placeholder.png';
  }
  
  const filename = match[1];
  console.log('Mapping image:', wikiImagePath, '-> filename:', filename);
  
  // Map common variations
  const imageMap: Record<string, string> = {
    'Walnutclintgoldcoconut.png': 'Walnutclintgoldcoconut.png',
    'Walnutgingerislandfishing.PNG': 'Walnutgingerislandfishing.png',
    'Walnuteastislandpath.PNG': 'Walnuteastislandpath.png',
    'Banana_Shrine.png': '263px-Banana_Shrine.png',
    'Walnuteastleohut.png': '263px-Walnuteastleohut.png',
    'Walnuteasthiddenshrine.png': '263px-Walnuteasthiddenshrine.png',
    'Walnutgembirdshrine.PNG': '263px-Walnutgembirdshrine.png',
    'Walnut_Harvest.png': 'Walnut_Harvest.png',
    'Walnutkribbitoutside.PNG': 'Walnutkribbitoutside.png',
    'Walnutlocation_Beach_curve.png': '263px-Walnutlocation_Beach_curve.png',
    'Musselfarming.PNG': 'Musselfarming.png',
    'Shipwreckindoor.PNG': 'Shipwreckindoor.png',
    'Walnutwestaroundthecliff.png': '263px-Walnutwestaroundthecliff.png',
    'Walnutwestbeachcircle.png': '263px-Walnutwestbeachcircle.png',
    'Walnutwestbypond.png': '263px-Walnutwestbypond.png',
    'Walnutwestcircleofgrass.png': '263px-Walnutwestcircleofgrass.png',
    'Walnutwesthiddenpath.png': '263px-Walnutwesthiddenpath.png',
    'Walnutwestoverlookingfarm.png': '263px-Walnutwestoverlookingfarm.png',
    'Walnutwestpathqiroom.png': '263px-Walnutwestpathqiroom.png',
    'Walnutwestpebblecircle.png': '263px-Walnutwestpebblecircle.png',
    'Walnutwesttigergrovehidden.png': '263px-Walnutwesttigergrovehidden.png',
    'Whackamole.png': '263px-Whackamole.png',
    'Ginger_Island_Mermaid.png': '263px-Ginger_Island_Mermaid.png',
    'Island_Field_Office.png': '263px-Island_Field_Office.png',
    'Walnutdownrivervolcano.png': '263px-Walnutdownrivervolcano.png',
    'Walnuthuntingmonsters.png': '263px-Walnuthuntingmonsters.png',
    'Walnutlocation4starfish.png': '263px-Walnutlocation4starfish.png',
    'Walnutnorthbehidntreevolcano.png': '263px-Walnutnorthbehidntreevolcano.png',
    'Walnutnorthcircle2.png': '263px-Walnutnorthcircle2.png',
    'Walnutnorthdigsiteright.png': '263px-Walnutnorthdigsiteright.png',
    'Walnutnorthflowercircle.png': '263px-Walnutnorthflowercircle.png',
    'Walnutnorthhiddengrove.png': '263px-Walnutnorthhiddengrove.png',
    'Walnutnorthonatree.png': '263px-Walnutnorthonatree.png',
    'Walnutquestbirdie.png': '263px-Walnutquestbirdie.png',
    'Walnuttopleftvolcano.png': '263px-Walnuttopleftvolcano.png',
    'Walnutpiratescovedarts.png': 'Walnutpiratescovedarts.png',
    'Walnutroutetosimonsays.png': 'Walnutroutetosimonsays.png',
    'Walnutslime_grove.png': 'Walnutslime_grove.png',
    'Walnutsouthpiratecove.png': 'Walnutsouthpiratecove.png',
    'Walnutsouthyellowstarfish.png': 'Walnutsouthyellowstarfish.png',
    'Walnutstarfishtidepool.png': 'Walnutstarfishtidepool.png',
    'Wanutwestexplorehidden.png': 'Wanutwestexplorehidden.png',
    'Walnutdigsiteleft.png': 'Walnutdigsiteleft.png',
    'Walnutfarmbeachlocation1.png': 'Walnutfarmbeachlocation1.png',
    'Walnutforge.png': 'Walnutforge.png',
    'Walnuthiddennorthsouthpassage.png': 'Walnuthiddennorthsouthpassage.png',
    'Walnutjournal10.png': 'Walnutjournal10.png',
    'WalnutlocationX.png': 'WalnutlocationX.png',
    'Walnutlocation_Birdienorth.png': 'Walnutlocation_Birdienorth.png',
    'Walnutnorthcircle1sized.png': 'Walnutnorthcircle1sized.png',
    'Walnutnorthcircle3.png': 'Walnutnorthcircle3.png',
    'WalnutNorthIslandDigsiteRamp.png': 'WalnutNorthIslandDigsiteRamp.png',
    'Walnutnorthvolcanonook.png': 'Walnutnorthvolcanonook.png',
    'Walnutnorthweirdsoil.png': 'Walnutnorthweirdsoil.png',
    'Walnutoutsideqi.png': 'Walnutoutsideqi.png',
  };
  
  const mappedFilename = imageMap[filename];
  if (mappedFilename) {
    const finalPath = `/images/walnuts/${mappedFilename}`;
    console.log('Mapped to:', finalPath);
    return finalPath;
  }
  
  // If no mapping found, try the original filename
  const fallbackPath = `/images/walnuts/${filename}`;
  console.log('No mapping found, using fallback:', fallbackPath);
  return fallbackPath;
}
